export default function TargetAudience() {
  const tradeCategories = [
    {
      title: 'Core Trades',
      trades: [
        'Electrical',
        'Plumbing',
        'HVAC',
        'Roofing',
        'Painting',
        'Flooring',
        'Concrete',
        'Carpentry'
      ]
    },
    {
      title: 'Specialty Services',
      trades: [
        'Pressure Washing',
        'Window Cleaning',
        'Lawn Care',
        'Pool Service',
        'Handyman',
        'Mobile Detailing',
        'Landscaping',
        'Pest Control'
      ]
    },
    {
      title: 'Growing Teams',
      trades: [
        'General Contractors',
        'Subcontractor Crews',
        'Solo Operators',
        'Home Service Businesses',
        'Property Maintenance',
        'Renovation Teams',
        'Construction Firms',
        'Facility Services'
      ]
    }
  ];

  return (
    <section className="bg-gradient-to-b from-blue-50 to-white py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Built for the trades that build everything
          </h2>
          <p className="text-lg text-gray-600">
            From common trades to underserved niches, we've got you covered
          </p>
        </div>

        {/* Trade Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {tradeCategories.map((category, index) => (
            <div key={index} className="space-y-5">
              <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider mb-5">
                {category.title}
              </h3>
              <ul className="space-y-3">
                {category.trades.map((trade, tradeIndex) => (
                  <li key={tradeIndex} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-600">{trade}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <p className="text-center text-gray-500 italic">
          Don't see your trade? We're adding more every week.
        </p>
      </div>
    </section>
  );
}
